<template>
  <main class="privacy-page">
    <header class="site-header">
      <img
        class="site-logo"
        :src="logo"
        alt="BOTTIMMO Turkoglu"
      />
    </header>

    <section class="hero">
      <h1>{{ $t('privacy-page.title') }}</h1>
    </section>

    <section class="content">
      <div class="content-container">
        <section class="legal-section">
          <h2>{{ $t('privacy-page.main.title') }}</h2>

          <p>{{ $t('privacy-page.main.intro') }}</p>

          <h3>{{ $t('privacy-page.data-controller.title') }}</h3>

          <p>{{ $t('privacy-page.data-controller.content.0') }}</p>
          <p>{{ $t('privacy-page.data-controller.content.1') }}</p>

          <h3>{{ $t('privacy-page.data-categories.title') }}</h3>

          <div class="privacy-table">
            <div class="privacy-table__header">
              <strong>{{ $t('privacy-page.data-categories.headers.category') }}</strong>
              <strong>{{ $t('privacy-page.data-categories.headers.examples') }}</strong>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.data-categories.rows.identity.label') }}</strong>
              <span>{{ $t('privacy-page.data-categories.rows.identity.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.data-categories.rows.contact.label') }}</strong>
              <span>{{ $t('privacy-page.data-categories.rows.contact.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>
                {{ $t('privacy-page.data-categories.rows.customer-transaction.label') }}
              </strong>
              <span>
                {{ $t('privacy-page.data-categories.rows.customer-transaction.value') }}
              </span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.data-categories.rows.finance.label') }}</strong>
              <span>{{ $t('privacy-page.data-categories.rows.finance.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.data-categories.rows.security.label') }}</strong>
              <span>{{ $t('privacy-page.data-categories.rows.security.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.data-categories.rows.marketing.label') }}</strong>
              <span>{{ $t('privacy-page.data-categories.rows.marketing.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.data-categories.rows.lead.label') }}</strong>
              <span>{{ $t('privacy-page.data-categories.rows.lead.value') }}</span>
            </div>
          </div>

          <h3>{{ $t('privacy-page.processing.title') }}</h3>

          <div class="privacy-table">
            <div class="privacy-table__header">
              <strong>{{ $t('privacy-page.processing.headers.purpose') }}</strong>
              <strong>{{ $t('privacy-page.processing.headers.legal-basis') }}</strong>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.processing.rows.contract.label') }}</strong>
              <span>{{ $t('privacy-page.processing.rows.contract.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.processing.rows.billing.label') }}</strong>
              <span>{{ $t('privacy-page.processing.rows.billing.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.processing.rows.support.label') }}</strong>
              <span>{{ $t('privacy-page.processing.rows.support.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.processing.rows.analytics.label') }}</strong>
              <span>{{ $t('privacy-page.processing.rows.analytics.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.processing.rows.legal-claims.label') }}</strong>
              <span>{{ $t('privacy-page.processing.rows.legal-claims.value') }}</span>
            </div>

            <div class="privacy-table__row">
              <strong>{{ $t('privacy-page.processing.rows.marketing.label') }}</strong>
              <span>{{ $t('privacy-page.processing.rows.marketing.value') }}</span>
            </div>
          </div>

          <p>{{ $t('privacy-page.processing.footer') }}</p>

          <h3>{{ $t('privacy-page.transfer.title') }}</h3>

          <p>{{ $t('privacy-page.transfer.intro') }}</p>

          <ul class="legal-list">
            <li>{{ $t('privacy-page.transfer.content.0') }}</li>
            <li>{{ $t('privacy-page.transfer.content.1') }}</li>
            <li>{{ $t('privacy-page.transfer.content.2') }}</li>
            <li>{{ $t('privacy-page.transfer.content.3') }}</li>
            <li>{{ $t('privacy-page.transfer.content.4') }}</li>
          </ul>

          <h3>{{ $t('privacy-page.collection.title') }}</h3>

          <p>{{ $t('privacy-page.collection.content') }}</p>

          <h3>{{ $t('privacy-page.retention.title') }}</h3>

          <p>{{ $t('privacy-page.retention.content') }}</p>

          <h3>{{ $t('privacy-page.cookies.title') }}</h3>

          <p>{{ $t('privacy-page.cookies.content') }}</p>

          <h3>{{ $t('privacy-page.rights.title') }}</h3>

          <p>{{ $t('privacy-page.rights.content') }}</p>

          <h3>{{ $t('privacy-page.application.title') }}</h3>

          <p>{{ $t('privacy-page.application.content.0') }}</p>
          <p>{{ $t('privacy-page.application.content.1') }}</p>
        </section>
      </div>
    </section>

    <footer class="site-footer">
      <div class="footer-container">
        <div class="footer-links">
          <strong>{{ $t('impressum-page.section-footer.title') }}</strong>
          <a
            target="_blank"
            :href="imprintUrl"
            rel="noopener noreferrer"
          >
            {{ $t('impressum-page.section-footer.content.0') }}
          </a>

          <a
            target="_blank"
            :href="publicDataPrivacyUrl"
            rel="noopener noreferrer"
          >
            {{ $t('impressum-page.section-footer.content.1') }}
          </a>

          <a
            target="_blank"
            :href="publicDataPrivacyUrl"
            rel="noopener noreferrer"
          >
            {{ $t('impressum-page.section-footer.content.2') }}
          </a>
        </div>

        <div class="footer-divider" />

        <div class="footer-company">
          © {{ currentYear }} {{ $t('impressum-page.section-footer.content.3') }}
          <span class="separator">·</span>
          {{ $t('impressum-page.section-footer.content.4') }}
          <br />
          {{ $t('impressum-page.section-footer.content.5') }}
        </div>
      </div>
    </footer>
  </main>
</template>

<script setup>
import { computed } from 'vue'

import logo from '@/assets/img/logo.png'
import { useBranding } from '@/composables/useBranding'

const currentYear = computed(() => new Date().getFullYear())
const { publicDataPrivacyUrl, imprintUrl } = useBranding()
</script>

<style scoped>
.privacy-page {
  min-height: 100vh;
  background: #fff;
  color: #303030;
  font-family: Inter, Arial, Helvetica, sans-serif;
}

.site-header {
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-top: 1px solid #e5e5e5;
}

.site-logo {
  display: block;
  width: 300px;
  max-width: 70%;
  max-height: 58px;
  object-fit: contain;
}

.hero {
  min-height: 400px;
  background: #00150d;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
}

.hero h1 {
  margin: 0;
  color: #fff;
  font-size: clamp(40px, 4vw, 64px);
  font-weight: 700;
  line-height: 1.1;
  text-align: center;
}

.content {
  width: 100%;
}

.content-container {
  width: min(100% - 80px, 1240px);
  margin: 0 auto;
  padding: 38px 0 42px;
}

.legal-section {
  margin-bottom: 38px;
}

.legal-section:last-child {
  margin-bottom: 0;
}

.legal-section h2 {
  margin: 0 0 20px;
  text-align: center;
  color: #303030;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
}

.legal-section h3 {
  margin: 32px 0 14px;
  color: #303030;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.25;
}

.legal-section p {
  margin: 0 0 16px;
  color: #8d8d8d;
  font-size: 24px;
  line-height: 1.48;
}

.legal-section p strong {
  color: #303030;
  font-weight: 700;
}

.content a {
  color: inherit;
  text-decoration: none;
}

.content a:hover {
  text-decoration: underline;
}

.privacy-table {
  width: 100%;
  margin: 24px 0 32px;
  border-top: 1px solid #e5e5e5;
}

.privacy-table__header,
.privacy-table__row {
  display: grid;
  grid-template-columns: minmax(260px, 38%) 1fr;
}

.privacy-table__header {
  background: #00150d;
  color: #fff;
  font-size: 20px;
  line-height: 1.4;
}

.privacy-table__header > *,
.privacy-table__row > * {
  padding: 12px 16px;
}

.privacy-table__row {
  border-bottom: 1px solid #e5e5e5;
  color: #8d8d8d;
  font-size: 20px;
  line-height: 1.45;
}

.privacy-table__row strong {
  color: #303030;
  font-weight: 700;
}

.legal-list {
  margin: 0 0 24px;
  padding-left: 28px;
  color: #8d8d8d;
  font-size: 24px;
  line-height: 1.48;
}

.legal-list li {
  margin-bottom: 12px;
}

.legal-list strong {
  color: #303030;
}

.site-footer {
  width: 100%;
  border-top: 1px solid #ededed;
  background: #fff;
}

.footer-container {
  width: min(100% - 80px, 1120px);
  margin: 0 auto;
  padding: 56px 0 32px;
}

.footer-links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  font-size: 20px;
  line-height: 1.35;
}

.footer-links strong {
  font-weight: 700;
}

.footer-links a {
  color: inherit;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-divider {
  height: 1px;
  width: 100%;
  background: #e5e5e5;
  margin: 42px 0 28px;
}

.footer-company {
  color: #696969;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.45;
}

.separator {
  display: inline-block;
  padding: 0 8px;
}

@media (max-width: 900px) {
  .site-header {
    height: 72px;
  }

  .site-logo {
    width: 240px;
  }

  .hero {
    min-height: 300px;
  }

  .content-container {
    width: min(100% - 48px, 1240px);
    padding-top: 34px;
  }

  .legal-section h2 {
    font-size: 24px;
  }

  .legal-section h3 {
    font-size: 21px;
  }

  .legal-section p,
  .legal-list {
    font-size: 19px;
  }

  .privacy-table__header,
  .privacy-table__row {
    font-size: 18px;
  }

  .footer-container {
    width: min(100% - 48px, 1120px);
  }
}

@media (max-width: 600px) {
  .site-header {
    height: 64px;
    padding: 10px 16px;
  }

  .site-logo {
    width: 200px;
  }

  .hero {
    min-height: 220px;
    padding: 40px 20px;
  }

  .hero h1 {
    font-size: 36px;
  }

  .content-container {
    width: calc(100% - 32px);
    padding: 28px 0 32px;
  }

  .legal-section {
    margin-bottom: 32px;
  }

  .legal-section h2 {
    margin-bottom: 16px;
    font-size: 21px;
  }

  .legal-section h3 {
    margin-top: 26px;
    margin-bottom: 10px;
    font-size: 19px;
  }

  .legal-section p,
  .legal-list {
    font-size: 17px;
    line-height: 1.5;
  }

  .legal-list {
    padding-left: 22px;
  }

  .privacy-table {
    margin: 20px 0 28px;
  }

  .privacy-table__header,
  .privacy-table__row {
    grid-template-columns: 1fr;
  }

  .privacy-table__header {
    font-size: 17px;
  }

  .privacy-table__header strong:last-child {
    display: none;
  }

  .privacy-table__row {
    font-size: 16px;
  }

  .privacy-table__header > *,
  .privacy-table__row > * {
    padding: 10px 12px;
  }

  .privacy-table__row strong {
    padding-bottom: 2px;
  }

  .privacy-table__row strong + * {
    padding-top: 2px;
  }

  .footer-container {
    width: calc(100% - 32px);
    padding: 40px 0 24px;
  }

  .footer-links {
    font-size: 17px;
  }

  .footer-divider {
    margin: 32px 0 22px;
  }

  .footer-company {
    font-size: 14px;
  }

  .separator {
    padding: 0 4px;
  }
}
</style>
